import React from 'react';

import style from './GameIFrame.scss';

export const GameIFrame = ({ src, className = '' }) => {
    return <iframe src={src} className={`${style.gameIFrame} game-iframe ${className}`} />;
};
